module.exports = __webpack_public_path__ + "img/security-2.f0527c2c.webp";